import { setupCalendar } from '@angelblanco/v-calendar'
import '@angelblanco/v-calendar/dist/style.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(setupCalendar, {})
})
